import React from "react"; 
import FileViewer from 'react-file-viewer';
import DocViewer, { DocViewerRenderers } from "react-doc-viewer";
import { imgProperties } from "@fluentui/react";
const DocIframe = ({ source }) => {
  if (!source) {
    return <div>Loading...</div>;
  }
  debugger;
 const src = source;  
 
 //const encodeddata =src?src.toString().split('base64,'):[];
 //const newimg= "data:image/jpg;base64,"+encodeddata[1];      
 
 const docs = [
    { uri: src },
    
  ];
  
  let encodedEmbedURL = encodeURIComponent(src);

  //const previewUri = Uri.EscapeDataString(encodedEmbedURL);
 // const fsrc= 
  
 return (
    <> 
    
    
  <iframe  aria-readonly={true}  style={{width:'100%', height:'480px', overflowY:'scroll',overflowX:'scroll', background:'white'}}
         src={"https://view.officeapps.live.com/op/embed.aspx?src="+ encodedEmbedURL}
       
         
        scrolling="no"
        width="100%"
        frameBorder={0}
       
        
      ></iframe> 
		 {/*
  <iframe  style={{width:'100%', height:'600px', overflowY:'scroll', background:'white'}}
         src={"https://docs.google.com/viewer?url=" + encodedEmbedURL+ "&embedded=true"}
        title="file"
        
        scrolling="no"
        width="100%"
       
        
      ></iframe> 
      
	 
	 <iframe
        src={"https://docs.google.com/viewer?url=" + encodedEmbedURL+ "&embedded=true"}
        title="file"
        
        scrolling="no"
        width="100%"
       
        style={{overflow:'auto'}}
      ></iframe> 
	  

	 <img src={newimg} style={{ height: 200, width: null, flex: 1 }} />
	 
	 	
		 
		 <iframe
        src={ src  }
        title="file"
        
        scrolling="no"
        width="100%"
       
      ></iframe> 
	  
	  
	 <FileViewer
        fileType={"xlsx"}
        filePath={src}
        errorComponent={(e)=>{}}
        onError={(e)=>{}}/>
	
	 <iframe
        src={"https://docs.google.com/viewer?url=" + src + "&embedded=true"}
        title="file"
        
        scrolling="no"
        width="100%"
       
      ></iframe> 
	<DocViewer 
	 pluginRenderers={DocViewerRenderers}
	documents={docs} 
	theme={{
		primary: "#5296d8",
		secondary: "#ffffff",
		tertiary: "#5296d899",
		text_primary: "#ffffff",
		text_secondary: "#5296d8",
		text_tertiary: "#00000099",
		disableThemeScrollbar: false,
	  }}
	/>
	 <iframe
        src={"https://docs.google.com/viewer?url=" + src + "&embedded=true"}
        title="file"
        
        scrolling="no"
        width="100%"
       
      ></iframe> 
	  
	 
	  <FileViewer
        fileType={"xlsx"}
        filePath={src}
        errorComponent={(e)=>{}}
        onError={(e)=>{}}/>
	 */}
	
        
    </ >
  );
  
  
   
};

export default DocIframe;
